import { FC } from 'react';

import { YbCoreButton } from '@yubi/yb-core-button-v3';
import { YbCoreButtonProps } from '@yubi/yb-core-button-v3/dist/dts/types';

type ButtonViewV3Props = Omit<YbCoreButtonProps, 'variant' | 'size'> & {
  variant?: YbCoreButtonProps['variant'];
  size?: YbCoreButtonProps['size'];
};

const ButtonViewV3: FC<ButtonViewV3Props> = ({
  variant = 'primary',
  size = 's',
  ...rest
}) => {
  return <YbCoreButton variant={variant} size={size} {...rest} />;
};

export default ButtonViewV3;
